import React from 'react'

const ColumnList = ({ title, items }) => (
  <div className="column">
    <h3>{title}</h3>
    {items.map(item =>
      <p key={item}>{item}</p>
    )}
  </div>
)

ColumnList.propTypes = {
}

export default ColumnList



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ColumnList.js